import { render, staticRenderFns } from "./Dashboardgraficos.vue?vue&type=template&id=090de322"
import script from "./Dashboardgraficos.vue?vue&type=script&lang=js"
export * from "./Dashboardgraficos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports